import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-faculty-dialog-box',
  templateUrl: './faculty-dialog-box.component.html',
  styleUrls: ['./faculty-dialog-box.component.scss']
})
export class FacultyDialogBoxComponent implements OnInit {
  FacultyForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  facultyList: any;
  faculty: string;
  isread = false;
  isreaddelete = false;
  APIService: any;
  deleteButton: boolean;
  dialogRef: MatDialogRef<any>;
  FacultyCreate=true;
  FacultyUpdate=true;
  FacultyDelete=true;
  userPermission: any;
  utp: string;
  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,   public router: Router,  private httpClient: HttpClient,
   private spinner: NgxSpinnerService,
   private dialogRef2:MatDialogRef<FacultyDialogBoxComponent>,
     ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
      this.userPermission.forEach(element => {
      if(element.PageName == 'Faculty' && element.PCreate == false)
      {
          this.FacultyCreate = false;  
      }
      if(element.PageName == 'Faculty' && element.PUpdate == false)
      {
          this.FacultyUpdate = false;  
      }   
      if(element.PageName == 'Faculty' && element.PDelete == false)
      {
          this.FacultyDelete = false;  
      } 
    });
  }
    window.scroll(0, 0);
    this.submitButton = true;
    this.editButton = false;
    this.getFacultyData();
    this.FacultyForm = this.fb.group({
      FcCode: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-z0-9-&]*$')]),
      FcDesc: new FormControl ('', [Validators.required]),
    });
   
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
    this.prepopulationForDelete(this.data.selected);
    } else {
      
    }
  }

  getFacultyData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getFaculty(payload).subscribe(res => {
      if(res.status){
        this.facultyList = res.data;
        this.spinner.hide();
      }else{
        this.spinner.hide();
      }
      
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.facultyList = [];
       
     });
  }

  prepopulation(id) {
    this.spinner.show();
    const payload = {};
    payload['FcCode'] = id.FcCode;
    this.umsService.getFaculty(payload).subscribe((res) => {
      this.spinner.hide();
      const data = res.data[0];
      if (res.status){
         this.editButton = true;
         this.isreaddelete = false;
         this.submitButton = false;
         this.isread = true;
         this.deleteButton  = false;
         this.FacultyForm = this.fb.group({
          FcCode: new FormControl (data.FcCode, [Validators.required, Validators.pattern('^[a-zA-z0-9-&]*$')]),
          FcDesc: new FormControl (data.FcDesc, [Validators.required]),
        });
       }else{
         
       }
     });
  }

  prepopulationForDelete(id){
    this.spinner.show();
    const payload = {};
    payload['FcCode'] = id.FcCode;
    payload['FcDesc'] = id.FcDesc;
    this.umsService.getFaculty(payload).subscribe((res) => {
      this.spinner.hide();
      const data = res.data[0];
      if (res.status) {
        this.editButton = false;
        this.submitButton = false;
        this.isreaddelete = true;
        this.deleteButton = true;
        this.FacultyForm = this.fb.group({
          FcCode: new FormControl (data.FcCode, [Validators.required, Validators.pattern('^[a-zA-z0-9-&]*$')]),
          FcDesc: new FormControl (data.FcDesc, [Validators.required]),

        });
      } else {
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef2.close();
        });

      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      this.dialogRef.afterClosed().subscribe((result) => {
        this.dialogRef2.close();
      });
      
   });
  }

  DeletetheRecord(){
    const  data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes'){
        this.deletedata(this.FacultyForm.value);
        this.dialogRef2.close();
      }else{
        this.dialogRef2.close();
      }
    });
   }
   deletedata(id){
    this.spinner.show();
    const options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),  body: {
      FcCode: id.FcCode,
      FcDesc: id.FcDesc
    },
  };
    this.httpClient.delete(this.APIService + '/masters/faculty', options)
    .subscribe((s) => {
      this.spinner.hide();
      let cc = [];
      cc.push(s);
      let  data = {}
      data['message'] = cc[0].message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        this.dialogRef2.close();
      });
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        this.dialogRef2.close();
      });
   });

   }

  submit(){
    if (this.FacultyForm.invalid) {
      this.FacultyForm.get('FcCode').markAsTouched();
      this.FacultyForm.get('FcDesc').markAsTouched();
      return;
    } else {
      this.ADDFaculty();
    }
  }

  ADDFaculty() {
    this.spinner.show();
    this.submitpayload = this.FacultyForm.value;
    this.umsService.addFaculty(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status){
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        
      } else {
        this.spinner.hide();
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      
    });
  }

  update(){
    if (this.FacultyForm.invalid) {
      this.FacultyForm.get('FcCode').markAsTouched();
      this.FacultyForm.get('FcDesc').markAsTouched();
      return;
    } else {
      this.updateFaculty();
    }
  }

  updateFaculty() {
    this.spinner.show();
    this.submitpayload = this.FacultyForm.value;
    this.umsService.updateFaculty(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status){
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      } else {
        this.spinner.hide();
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {} 
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
    });
  }

} 
